import React, { useEffect, useState } from 'react';
import {
    login,
    loginWith2FA,
    sendOtpToUsername,
    showToast,
    useAppDispatch,
} from '@hypexone/uicore';
import { connect } from 'react-redux';
import { authClient } from '../../../App';
interface ResetTwoFactorProps {
    langData: any;
    onBack: () => void;
    onSuccess: () => void;
    sendOtpToUsername: (event: any) => void;
    pendingLoginData: {
        username: string;
        password: string;
    } | null;
    navigate: (path: string, options?: any) => void;
}

const ResetTwoFactor: React.FC<ResetTwoFactorProps> = ({
    langData,
    onBack,
    onSuccess,
    sendOtpToUsername,
    pendingLoginData,
    navigate,
}) => {
    const [option, setOption] = useState('PHONE_NUMBER');
    const [phone, setPhone] = useState<any>('');
    const [email, setEmail] = useState<string>('');
    const [country, setCountry] = useState<any>('');
    const [phoneFormat, setPhoneFormat] = useState<any>('');
    const [otp, setOtp] = useState('');
    const [otpTimer, setOtpTimer] = useState<number>();
    const [otpEnterFields, setOtpEnterFields] = useState<boolean>(false);
    const [otpErrorMessage, setOtpErrorMessage] = useState<string>('');
    const [phoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [isResetting, setIsResetting] = useState<boolean>(false);
    const [recoveryCode, setRecoveryCode] = useState('');
    const [isRecoveryLoading, setIsRecoveryLoading] = useState(false);
    const [availableOptions, setAvailableOptions] = useState<string[]>([]);
    const [isFetchingOptions, setIsFetchingOptions] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const getRecoveryOptions = async () => {
            if (!pendingLoginData?.username) return;
            try {
                setIsFetchingOptions(true);
                const response: any = await authClient.fetchRecoveryOptions({
                    username: pendingLoginData.username,
                });
                const options = Array.isArray(response?.data) ? response.data : [];
                setAvailableOptions(options);
                if (options.length === 1) {
                    setOption(options[0]);
                } else if (options.includes('PHONE_NUMBER')) {
                    setOption('PHONE_NUMBER');
                } else if (options.includes('RECOVERY_CODE')) {
                    setOption('RECOVERY_CODE');
                }
            } catch (err) {
                setAvailableOptions(['PHONE_NUMBER']);
                setOption('PHONE_NUMBER');
            } finally {
                setIsFetchingOptions(false);
            }
        };

        getRecoveryOptions();
    }, [pendingLoginData?.username]);
    const handleOtpTimer = (time: number) => {
        if (time >= 0) {
            setOtpTimer(time);
            setTimeout(() => {
                handleOtpTimer(time - 1);
            }, 1000);
        } else {
            setTimeout(() => {
                setOtpTimer(undefined);
            }, 1000);
        }
    };

    const generateOtp = async () => {
        setPhoneNumberErrorMsg('');
        try {
            setLoading(true);
            // const identifier = option === 'Email' ? email : phone;
            // const userIdentifierType = option === 'Email' ? 'EMAIL' : 'PHONE_NUMBER';
            await sendOtpToUsername({
                username: '',
                phonenumber: '91' + phone,
                option: option === 'PHONE_NUMBER' ? 'mobile' : 'email',
                email: email,
            });
            setOtpEnterFields(true);
            handleOtpTimer(30);
        } catch (err) {
            setPhoneNumberErrorMsg(
                err?.response?.data?.message || 'Failed to send OTP'
            );
        } finally {
            setLoading(false);
        }
    };

    const resetTwoFactor = async () => {
        try {
            setIsResetting(true);
            const payload = {
                userIdentifier: 'PHONE_NUMBER',
                identifierValue: '91' + phone,
                otp: otp,
            };
            const response: any = await authClient.reset2FA(payload);

            if (response.status === 200) {
                dispatch(showToast({ type: 'success', message: 'Reset 2FA successful' }));
                onSuccess();
            } else {
                dispatch(showToast({ type: 'error', message: response?.response?.data?.message || 'Failed to reset 2FA' }));
            }
        } catch (err) {
            dispatch(showToast({ type: 'error', message: err?.response?.data?.message || 'Failed to reset 2FA' }));
        } finally {
            setIsResetting(false);
        }
    };

    const formatOTPInput = (value: string) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 6);
        return numericValue;
    };

    const handleOTPChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const formattedValue = formatOTPInput(e.target.value);
        setOtp(formattedValue);
    };

    const handleRecoveryCodeLogin = async () => {
        if (!pendingLoginData || !recoveryCode.trim()) return;
        try {
            setIsRecoveryLoading(true);
            await dispatch(
                loginWith2FA({
                    username: pendingLoginData.username,
                    password: pendingLoginData.password,
                    otp: "",
                    recoveryCode: recoveryCode.trim(),
                    navigate,
                })
            ).unwrap();
            dispatch(
                showToast({
                    type: 'success',
                    message: langData?.['login_success'] || 'Login Successful',
                })
            );
            onSuccess();
        } catch (err: any) {
            console.log(err);
        } finally {
            setIsRecoveryLoading(false);
        }
    };

    return (
        <form
            className="login-form-ctn flex flex-col gap-4 rounded-lg w-full md:px-4"
            autoComplete="off"
        >
            <div className="back-icon cursor-pointer" onClick={onBack}>
                <div className="back flex items-center gap-2">
                    {/* <img src={BackArrow} className="arrow-clr w-5 h-5" alt="back" /> */}
                    <span className="back-text text-white hover:text-gray-200 transition-colors">
                        {langData?.['back'] || 'Back'}
                    </span>
                </div>
            </div>

            <div className="card-title text-xl font-bold text-white">
                {langData?.['reset_two_factor_auth'] ||
                    'Reset Two-Factor Authentication'}
            </div>
            <span className="card-login-here block text-white leading-relaxed">
                {langData?.['reset_2fa_description'] ||
                    'Enter your phone number to reset your Two-Factor Authentication. You will receive an OTP to verify your identity.'}
            </span>

            {isFetchingOptions ? (
                <div className="text-center text-white text-sm py-4">
                    {langData?.['loading'] || 'Loading...'}
                </div>
            ) : (
                <>
                    {availableOptions.length > 1 && (
                        <div className="method-selection-container mt-2 w-full">
                            <div className="method-tabs flex bg-white/10 rounded-xl p-1 gap-1">
                                {availableOptions.includes('PHONE_NUMBER') && (
                                    <button
                                        type="button"
                                        className={`flex-1 px-4 py-2 border-none rounded-lg text-sm ${option === 'PHONE_NUMBER' ? 'bg-blue-600 text-white' : 'text-white/80 bg-transparent'}`}
                                        onClick={() => {
                                            setOption('PHONE_NUMBER');
                                            setPhoneNumberErrorMsg('');
                                            setOtpEnterFields(false);
                                        }}
                                    >
                                        {langData?.['phone_number'] || 'Phone Number'}
                                    </button>
                                )}
                                {availableOptions.includes('RECOVERY_CODE') && (
                                    <button
                                        type="button"
                                        className={`flex-1 px-4 py-2 border-none rounded-lg text-sm ${option === 'RECOVERY_CODE' ? 'bg-blue-600 text-white' : 'text-white/80 bg-transparent'}`}
                                        onClick={() => {
                                            setOption('RECOVERY_CODE');
                                            setPhoneNumberErrorMsg('');
                                            setOtpEnterFields(false);
                                        }}
                                    >
                                        {langData?.['recovery_code'] || 'Recovery Code'}
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

                    {option === 'RECOVERY_CODE' ? (
                        <>
                            <div className="input-container w-full">
                                <div className="usr-input w-full">
                                    <label className="input-labell block font-semibold mb-2 text-white uppercase text-sm">
                                        {langData?.['recovery_code'] || 'Recovery Code'}{' '}
                                        <span className="red-text text-red-500">*</span>
                                    </label>
                                    <input
                                        className="login-input-field user-name w-full h-[38px] px-3 bg-transparent text-center border border-white rounded text-white placeholder-white/20 placeholder:text-xs focus:outline-none focus:border-blue-300"
                                        type="text"
                                        value={recoveryCode}
                                        onChange={(e) => setRecoveryCode(e.target.value)}
                                        placeholder={langData?.['enter_recovery_code'] || 'Enter Recovery Code'}
                                    />
                                </div>
                            </div>

                            <div className="login-demologin-btns">
                                <button
                                    type="button"
                                    className="login-form-btn-without-demologin w-full h-12 rounded-xl font-semibold text-base normal-case shadow-[0_4px_12px_rgba(79,209,197,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_6px_16px_rgba(79,209,197,0.4)] disabled:translate-y-0 disabled:shadow-none disabled:opacity-60 bg-blue-600 hover:bg-blue-700 text-white"
                                    onClick={handleRecoveryCodeLogin}
                                    disabled={isRecoveryLoading || !recoveryCode.trim() || recoveryCode.length !== 10}
                                >
                                    {isRecoveryLoading
                                        ? langData?.['loading'] || 'Loading...'
                                        : langData?.['verify_and_login'] || 'Verify & Login'}
                                </button>
                            </div>
                        </>
                    ) : !otpEnterFields ? (
                        <>
                            {/* <div className="method-selection-container mt-5 w-full">
            <div className="method-tabs flex bg-white/10 rounded-xl p-1 gap-1 max-md:flex-col max-md:gap-2 max-md:p-2">
              <Button
                className={`method-tab flex-1 px-4 py-3 border-none rounded-lg bg-transparent text-white/70 font-medium text-sm cursor-pointer transition-all duration-300 flex items-center justify-center gap-2 hover:bg-white/10 hover:text-white/90 max-md:px-3 max-md:py-2.5 max-md:text-[13px] ${
                  option === 'Phone number'
                    ? 'active bg-[var(--ion-color-primary)] text-[var(--active-text-color)] shadow-[0_2px_8px_rgba(79,209,197,0.3)]'
                    : ''
                }`}
                onClick={() => {
                  setOption('Phone number');
                  setPhone('');
                  setEmail('');
                  setPhoneNumberErrorMsg('');
                }}
              >
                {langData?.['phone_number'] || 'Phone Number'}
              </Button>
              <Button
                className={`method-tab flex-1 px-4 py-3 border-none rounded-lg bg-transparent text-white/70 font-medium text-sm cursor-pointer transition-all duration-300 flex items-center justify-center gap-2 hover:bg-white/10 hover:text-white/90 max-md:px-3 max-md:py-2.5 max-md:text-[13px] ${
                  option === 'Email'
                    ? 'active bg-[var(--ion-color-primary)] text-[var(--active-text-color)] shadow-[0_2px_8px_rgba(79,209,197,0.3)]'
                    : ''
                }`}
                onClick={() => {
                  setOption('Email');
                  setPhone('');
                  setEmail('');
                  setPhoneNumberErrorMsg('');
                }}
              >
                {langData?.['email'] || 'Email'}
              </Button>
            </div>
          </div> */}

                            <div className="input-container w-full">
                                {option === 'PHONE_NUMBER' ? (
                                    <div className="usr-input w-full">
                                        <label className="input-labell block font-semibold mb-2 text-white uppercase text-sm">
                                            {langData?.['phone_number'] || 'Phone Number'}{' '}
                                            <span className="red-text text-red-500">*</span>
                                        </label>
                                        <input
                                            className="login-input-field user-name w-full h-[38px] px-3 bg-transparent text-center border border-white rounded text-white placeholder-white/20 placeholder:text-xs focus:outline-none focus:border-blue-300"
                                            type="text"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            placeholder={langData?.['enter_phone_number_txt'] || 'Enter Phone Number'}
                                            maxLength={10}
                                        />
                                    </div>
                                ) : (
                                    <div className="usr-input w-full">
                                        <label className="input-labell block font-semibold mb-2 text-white uppercase text-sm">
                                            {langData?.['email'] || 'Email'}{' '}
                                            <span className="red-text text-red-500">*</span>
                                        </label>
                                        <input
                                            className="login-input-field user-name w-full h-[38px] px-3 bg-transparent text-center border border-white rounded text-white placeholder-white placeholder:text-xs focus:outline-none focus:border-blue-300"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder={langData?.['enter_email_txt'] || 'Enter Email'}
                                            maxLength={50}
                                        />
                                    </div>
                                )}
                                {phoneNumberErrorMsg && (
                                    <span className="login-err-msg text-red-500 text-sm">
                                        {phoneNumberErrorMsg}
                                    </span>
                                )}
                            </div>

                            <div className="login-demologin-btns">
                                <button
                                    type="button"
                                    className="login-form-btn-without-demologin w-full h-12 rounded-xl font-semibold text-base normal-case shadow-[0_4px_12px_rgba(79,209,197,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_6px_16px_rgba(79,209,197,0.4)] disabled:translate-y-0 disabled:shadow-none disabled:opacity-60 bg-blue-600 hover:bg-blue-700 text-white"
                                    onClick={generateOtp}
                                    disabled={
                                        loading || (option === 'PHONE_NUMBER' ? !phone : !email)
                                    }
                                >
                                    {loading ? 'Loading...' : langData?.['send_otp'] || 'Send OTP'}
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            {otpTimer && (
                                <div className="text-center text-white text-sm">
                                    {langData?.['otp_timer'] || 'Resend OTP in'} {otpTimer}s
                                </div>
                            )}

                            <div className="code-input w-full">
                                <label className="input-labell block font-semibold mb-2 text-white uppercase text-sm">
                                    {langData?.['enter_otp'] || 'Enter OTP'}{' '}
                                    <span className="red-text text-red-500">*</span>
                                </label>
                                <input
                                    className="login-input-field user-name w-full h-[38px] px-3 bg-transparent text-center border border-white rounded text-white placeholder-white/20 placeholder:text-xs focus:outline-none focus:border-blue-300"
                                    type="text"
                                    value={otp}
                                    onChange={handleOTPChange}
                                    placeholder="123456"
                                    maxLength={6}
                                />
                            </div>

                            <div className="login-demologin-btns">
                                <button
                                    type="button"
                                    className="login-form-btn-without-demologin w-full h-12 rounded-xl font-semibold text-base normal-case shadow-[0_4px_12px_rgba(79,209,197,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_6px_16px_rgba(79,209,197,0.4)] disabled:translate-y-0 disabled:shadow-none disabled:opacity-60 bg-blue-600 hover:bg-blue-700 text-white"
                                    onClick={resetTwoFactor}
                                    disabled={isResetting || !otp || otp.length !== 6}
                                >
                                    {isResetting ? 'Loading...' : langData?.['verify_and_reset'] || 'Verify & Reset 2FA'}
                                </button>
                            </div>
                        </>
                    )}
                </>
            )}

            <div className="p-3 bg-white/10 border border-white/20 rounded-lg flex items-start gap-2.5">
                <span className="text-white text-base">ℹ️</span>
                <p className="m-0 text-white text-sm leading-relaxed">
                    {langData?.['reset_2fa_help'] ||
                        'If you are unable to access your authenticator app, this will help you reset your Two-Factor Authentication. You will need to set it up again after reset.'}
                </p>
            </div>
        </form>
    );
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        sendOtpToUsername: (event: any) => dispatch(sendOtpToUsername(event)),
    };
};

export default connect(null, mapDispatchToProps)(ResetTwoFactor);